import { useState } from 'react';

export interface UseChangeEmailFormStateReturn {
  email: string;
  setEmail: (value: string) => void;
  isValid: boolean;
  reset: () => void;
}

const EMAIL_REGEX: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const useChangeEmailFormState = (
  currentEmail: string
): UseChangeEmailFormStateReturn => {
  const [email, setEmailState] = useState<string>('');

  const setEmail = (value: string) => {
    setEmailState(value);
  };

  const reset = () => {
    setEmailState('');
  };

  const trimmed: string = email.trim();

  const isValid: boolean =
    EMAIL_REGEX.test(trimmed) &&
    trimmed.toLowerCase() !== currentEmail.trim().toLowerCase();

  return {
    email,
    setEmail,
    isValid,
    reset,
  };
};
